import { combineReducers } from "redux";

// Front
import Layout from "./layout/reducer";
// Authentication
import Login from "./auth/login/reducer";
import Profile from "./auth/profile/reducer";

import Invoices from "./invoices/reducer";
import Requisitions from "./requisitions/reducer";
import ConfigInit from "./Config/reducer";
import AreaReducer from "./Areas/reducer";
import TypePropertyReducer from "./CatTypeProperties/reducer";
import PropertyReducer from "./Property/reducer";
import ReportsReducer from "./Reports/reducer";
import PlatformAdminReducer from "./PlatformAdmin/reducer";

const rootReducer = combineReducers({
  Layout,
  Login,
  Profile,
  Invoices,
  Requisitions,
  ConfigInit,
  PropertyReducer,
  AreaReducer,
  TypePropertyReducer,
  ReportsReducer,
  PlatformAdminReducer
});

export default rootReducer;
